<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-06-28 11:25:12
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-20 16:58:20
-->
<template>
  <div class="nav">
    <!-- 导航 -->
    <el-menu
      router
      unique-opened
      :default-active="path"
      background-color="#3C424D"
      class="left-nav"
      text-color="#fff"
    >
      <template v-for="(menu, index) in accessMenu">
        <div v-if="!menu.children" class="meun-box">
          <div v-if="menu.isShow">
            <div
              class="one-box nav-one-style"
              v-if="selectIndex == index"
              @click="selectChild(index, menu)"
            >
              <i  class="icon-font" :class="menu.icon"></i>
              <div slot="title">{{ menu.title }}</div>
            </div>
            <div class="one-box" v-else @click="selectChild(index, menu)">
              <i class="icon-font"  :class="menu.icon"></i>
              <div slot="title">{{ menu.title }}</div>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-if="menu.isShow">
            <div
             class="one-box nav-one-style"
              v-if="selectIndex == index"
              @click="selectChild(index, menu)"
            >
              <i class="icon-font"  :class="menu.icon"></i>
              <div slot="title">{{ menu.title }}</div>
            </div>
            <div class="one-box" v-else @click="selectChild(index, menu)">
              <i class="icon-font"  :class="menu.icon"></i>
              <div slot="title">{{ menu.title }}</div>
            </div>
          </div>
        </div>
      </template>
    </el-menu>
    <div class="child-box" v-if="twoMenu.length > 0 && !isCollapse">
      <div class="two-title">
        {{ selectName }}
      </div>
      <div v-for="(item, index) in twoMenu">
        <div v-if="item.isShow" class="menu-group">{{ item.groupName }}</div>
        <div
          :class="twoSelectIndex == `${index}-${twoIndex}`?'two-select':'two-child-style'"
          @click="selectTwoMenu(`${index}-${twoIndex}`, itemTwo)"
          v-for="(itemTwo, twoIndex) in item.group"
          v-if="itemTwo.isShow"
        >
        <div :class="twoSelectIndex == `${index}-${twoIndex}`?'select-icon':''"></div>
          {{ itemTwo.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menusTwo from "@/utils/route";
import {selectRoleMenu} from '@/api/common'
export default {
  // 数据
  data() {
    return {
      accessMenu: [],
      twoMenu: [],
      selectIndex: "",
      twoSelectIndex: 0,
      selectName: "",
      menus:JSON.parse(JSON.stringify(menusTwo)),
    };
  },
  props: ["isCollapse"],
  // 计算属性
  computed: {
    path() {
      if (this.$route.path === "/index/goodsedit") return "/index/goodslist";
      if (this.$route.path === "/index/orderdetail") return "/index/order";

      return this.$route.path;
    },
  },
  created() {
    // 把菜单中满足权限的过滤出来
    let codeArray = [];
    const menus = this.menus;
    selectRoleMenu({
      id:JSON.parse(sessionStorage.getItem('userInfo')).id,
    }).then((res)=>{
        if(res.code == 0){
             
             // 获取到所有的权限 code
              for (let index = 0; index < res.data.length; index++) {
                    codeArray.push(res.data[index].code)
              }
            // 在菜单中对比
              for (let indexMen = 0; indexMen < menus.length; indexMen++) {
                   if(codeArray.indexOf( menus[indexMen].code) != -1){
                        menus[indexMen].isShow = true;
                        if(menus[indexMen].children && menus[indexMen].children.length > 0){
                          for (let indexChildren = 0; indexChildren < menus[indexMen].children.length; indexChildren++) {
                              for (let childrenTwo = 0; childrenTwo < menus[indexMen].children[indexChildren].group.length; childrenTwo++) {
                                 if(codeArray.indexOf(menus[indexMen].children[indexChildren].group[childrenTwo].code) != -1){
                                      menus[indexMen].children[indexChildren].group[childrenTwo].isShow = true;
                                      menus[indexMen].children[indexChildren].isShow = true;
                                  }
                              }
                          }
                      }
                   }
                 }
          sessionStorage.setItem('menuData',JSON.stringify(codeArray))
          this.accessMenu = JSON.parse(JSON.stringify(menus));
          this.$emit('showContent')
          this.changeRoute();
        }
    })
  },
  watch: {
    $route() {
      this.changeRoute();
    },
  },
  methods: {
    selectChild(index, menu) {
      this.selectIndex = index;
      if (this.menus[index].children) { 
      // 默认路由跳转 第一个二级路由
       let children = menu.children && menu.children.filter(x=>{ // 找到有权限的二级路由
            return x.isShow==true;
        })
        menu.children = children;
        // 找到有权限的二级路由的路由信息
        let group = menu.children && menu.children[0] && menu.children[0].group && menu.children[0].group.filter(x=>{
            return x.isShow==true;
        })
        this.twoMenu = JSON.parse(JSON.stringify(this.menus[index].children));
        //this.twoSelectIndex = 0; 暂时没发现有选中问题
        this.$router.push(group[0].path).catch(()=>{}); // 跳转
        this.selectName = this.menus[index].title;
      } else {
        this.twoMenu = JSON.parse(JSON.stringify([]));
        this.$router.push(menu.path).catch(()=>{});
      }
    },
    selectTwoMenu(twoIndex, menu) {
      if(menu.path == '/index/content/manuscripts'){
           let routeData = this.$router.resolve({ path: "/index/content/manuscripts" });
            window.open(routeData.href, '_blank');
      }else{
        this.twoSelectIndex = twoIndex;
        this.$router.push(menu.path).catch(()=>{});
      }
    },
    changeRoute() {
      this.menus.forEach((element, index) => {
        if (element.children) {
          element.children.forEach((twoElement, twoIndex) => {
            twoElement.group.forEach((threeElement, threeIndex) => {
              if (threeElement.children && this.$route.query.islast) {
                threeElement.children.forEach((fourElement, fourIndex) => {
                  if (fourElement.path == this.$route.path) {
                    this.selectIndex = index;
                    this.twoSelectIndex = twoIndex + "-" + threeIndex;
                    this.twoMenu = JSON.parse(
                      JSON.stringify(this.menus[index].children)
                    );
                    this.selectName = this.menus[index].title;
                  }
                });
              } else {
                if (threeElement.path == this.$route.path) {
                  this.selectIndex = index;
                  this.twoSelectIndex = twoIndex + "-" + threeIndex;
                  this.twoMenu = JSON.parse(
                    JSON.stringify(this.menus[index].children)
                  );
                  this.selectName = this.menus[index].title;
                }
              }
            });
          });
        } else {
          if (element.path == this.$route.path) {
            this.selectIndex = index;
            this.twoMenu = JSON.parse(JSON.stringify([]));
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.nav {
  //flex: 0 0 100px;
  display: flex;
  background-color: #304156;
  .logo {
    width: 200px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .el-menu {
    border-right: 0;
    .el-menu-item {
      i {
        color: #fff;
        margin-right: 10px;
      }
    }
  }
  .el-submenu {
    .el-submenu__title {
      i {
        color: #fff;
        margin-right: 10px;
      }
    }
    /deep/.el-menu {
      .el-menu-item {
        background-color: #202f3f !important;
      }
    }
  }
}
.child-box {
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(229, 229, 229, 1);
  padding-left: 8px;
  padding-right: 8px;
  width: 160px;
}
.selectMenu {
  background: red;
}
.one-box {
  text-align: center;
  cursor: pointer;
  color: #fff;
  padding: 15px 13px;
  width: 76px;
  color: rgba(186, 193, 204, 1);
  font-size: 14px;
  text-align: center;
  font-family: Roboto-regular;
}
.iconfont {
  font-size: 22px;
}
.two-child-style {
  // font-size: 14px;
  // font-weight: 550;
  // padding: 16px;
  // padding-left: 20px;
  // padding-bottom: 0px;
  // cursor: pointer;
  text-align: left;
  padding: 10px 0px;
  margin-left: 26px;
  cursor: pointer;
  color: rgba(102, 111, 128, 1);
  font-family: HarmonyOS_Sans_SC-regular;
  font-size: 14px;
}
.two-title {
  color: rgba(48, 49, 51, 1);
  font-size: 18px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-bold;
  font-weight: 600;
  padding-top: 29px;
  margin-bottom: 29px;
  margin-left: 26px;
}
.menu-group {
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
  margin-left: 26px;
  margin-bottom: 11px;
  margin-top: 11px;
}
.icon-font{
  font-size: 24px;
}
.nav-one-style{
  background-color: rgba(78, 86, 102, 1);
  text-align: center;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  text-align: center;
  font-family: Roboto-regular;
}
.two-select{
  padding: 10px 0px;
  border-radius: 8px;
  background-color: rgba(241, 243, 245, 1);
  text-align: center;
  display: flex;
  align-items: center;
  color: rgba(23, 109, 230, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-regular;
  cursor: pointer;
}
.select-icon{
  width: 6px;
  height: 20px;
  line-height: 20px;
  border-radius: 0px 4px 4px 0px;
  background-color: rgba(23, 109, 230, 1);
  text-align: center;
  margin-right: 20px;
}
</style>
